// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__egET8","country":"footer_country__r3xXy","footerLinks":"footer_footerLinks__8VWkY","linksSection":"footer_linksSection__C5Pq0"};